/*
ROUTES are used to navigate throught any components 
Every subpages are represented as objects inside main object which depicts  the same name of that page
*
*
SERVICE_URLS are apis that are needed to be fetched to get the data from backend
//
//
*/
const getApiHost = () => {
  const { protocol, hostname } = window.location;

  return `${protocol}//${hostname}/backend/`;
};
export const constants = {
  SUCCESS: 'success',
  FAILURE: 'failure',

  // THIRD_PARTY_API_HOST: 'http://localhost:8080/',
   THIRD_PARTY_API_HOST: getApiHost(),
  //THIRD_PARTY_API_HOST: 'https://apps.ace.xebia.com/app2/',
  // THIRD_PARTY_API_HOST: 'https://xtbackend.xebia.in/',
  THIRD_PARTY_IMAGE_HOST: 'http://localhost:8000/',

  ROUTES: {
    LOGIN: '/',
    NOT_FOUND: '/not-found',
    SUPER_ADMIN: '/admin',
    TESTGEN_CONFIG: '/configuration',
    HOME: '/home',
    BUG_CREATION: '/bugCreation',
    PARSE_REQUIREMENT: '/parseRequirement',
    VIEW_REQUIREMENT: '/viewdata',
    TEST_DATA_MANAGEMENT: '/testdatageneration',
    TEST_CONFIG: '/testdesign',
    VIEW_INTEGRATION: '/view3rdPartyIntegration',
    DESIGN_HOME: '/testmanagement', 
    VERSION: '3.1.0'
  },
  MB_EVENTS: {
    OPEN_OVERLAY: 'OPEN_OVERLAY'
  },
  TEMPLATE_NAMES: {
    SCREEN_SHORT_VIEW: 'SCREEN_SHORT_VIEW',
    FORM_VIEW: 'FORM_VIEW',
    USER_MANAGEMENT_POPUP_VIEW: 'USER_MANAGEMENT_POPUP_VIEW'
  },
  SERVICE_URLS: {
    LOGIN: 'login',
    CREATE_CUSTOMER: 'customer',
    CREATE_USER: 'user',
    CHANGE_PSWD: 'api/user/changePassword',
    CHAT_GPT_API: 'api/gpt/action',
    SHOW_STEP1: 'api/test-gen/steps/step1',
    SHOW_STEP2: 'api/test-gen/steps/step2',
    SHOW_STEP3: 'api/test-gen/steps/step3',
    RESPONS_ACCURACY: 'adversarial-prompts',
    SHOW_MANUAL_STEP1: 'api/test-gen/steps/tc',
    SHOW_MANUAL_STEP2: 'api/test-gen/steps/tc/1',
    SHOW_WEB_STEP1: 'api/test-gen/steps/ui/1',
    PYTHON_CREATE: 'api/py-gen/test/create',
    PYTHON_GENERATE: 'api/py-gen/test/generate',
    PYTHON_ADD: 'api/py-gen/test/add',
    SHOW_WEB_STEP2: 'api/test-gen/steps/ui/2',
    SHOW_WEB_STEP3: 'api/test-gen/steps/ui/3',
    SAMPLE_DATA_API: 'api/test-gen/steps/data/check',
    GENERATE_DATA_API: 'api/test-gen/steps/data/action',
    SAVE_DATA_API: 'api/test-gen/steps/data/action/query',
    INTEGRATION_API: 'api/integration',
    CHECK_API_DATA: 'api/prompt/classify',
    FILE_UPLOAD: 'api/test-gen/steps/document/view',
    FILE_ATTACHEMENT: 'genai/defects/attachments/upload',
    ASSESS_QUALITY: 'api/test-gen/steps/assess-quality',
    // JIRA_INTEGRATION: 'api/test-gen/steps/issue/',
    JIRA_INTEGRATION: 'api/test-gen/steps/issue',
    JIRA_COMMENT: 'api/jira/comment-attach',
    BUG_PREVIEW: 'genai/defects/preview',
    CREATE_BUG: 'genai/defects/create',
    GPT_SAVE_API: 'api/data/save',
    GET_GPT_DATA: 'api/data/',
    LLM_CONFIG: 'api/org/llm',
    INTEGRATION_DATA: 'api/config',
    INTEGRATION_NEW: 'api/config/user/',
    PROJECT_API: 'genai/defects/projects/',
    CONFIG_DEFAULT: 'api/user/',
    ANALYZE_BUG: 'genai/defects/analyze',
    PREVIEW_BUG: 'genai/defects/bug/preview',
    CUSTOMERS: {
      CREATE: 'api/customers/customer',
      FETCH: 'api/customers'
    },
    USER_MANAGEMENT: {
      FETCH: 'api/user',
      FETCH_LIST: 'api/user/customer/{customerName}/users',
      ENABLE: 'api/user/enable',
      GET_ROLES: 'api/user/roles',
      EDIT: '/projectSettings/userManagment/editUserManagement'
    }
  },
  NO_DATA_FOUND: 'No results found...'
};

